<template>
  <section
    class="sidearm-mm-hero-sunday desktop text-white relative bg-size-cover bg-position-center relative overflow-hidden h-100"
    data-anchor="home"
  >
    <section-background css_var="--section-desktop-bg-selection-sunday-hero"></section-background>
    <video-background
      v-if="section.background_type === 'video'"
      :video="section.background_video"
    />

    <animated-text :speed="animation_speed" :text="$root.data.school.name" />

    <background-element
      class="sidearm-mm-hero-sunday__background-element  col-3-of-8 absolute"
    />

    <div
      class="flex flex-align-center h-100 sidearm-mm-hero-sunday__inner relative"
    >
      <div class="sidearm-mm-hero-sunday__details col-3-of-8 col-push-1 pr-2">
        <ad
          name="tournament-experience-cs-hero-1"
          :sport-id="$root.sport_id"
          class="mb-2"
        />
        <!-- <img src="https://dummyimage.com/150x50/1C453B/ffffff" alt="" /> -->

        <h2 class="type-heading-bracket-plain --light ma-0 my-2">
          Selection {{ this.$root.selection_day_text }}
        </h2>

        <h3
          v-if="section.title"
          class="type-hero mt-0 mb-4"
          :class="{ '--long': section.title.length > 16 }"
        >
          {{ section.title }}
        </h3>

        <p v-if="section.sub_title" class="type-paragraph-large ma-0">
          {{ section.sub_title }}
        </p>
      </div>

      <div class="sidearm-mm-hero-sunday__divider col-1-of-8 relative">
        <span></span>
      </div>
    </div>
  </section>
</template>

<script>
import AnimatedText from "@/components/AnimatedText.vue";
import BackgroundElement from "@/components/Globals/BackgroundElement";

export default {
  props: {
    section: { type: Object, required: true }
  },

  components: {
    AnimatedText,
    BackgroundElement
  },

  data: () => ({
    animation_speed: "20s",
    selection_day_text: "Show"
  }),
  mounted() {
    this.selection_day_text = this.$root.selection_day_text;
  }
};
</script>

<style lang="scss" scoped>
.#{$prefix}-hero-sunday.desktop {

  .#{$prefix}-hero-sunday {
    &__inner {
      padding-top: 180px;
    }
    &__background-element {
      height: calc(50% + 120px);
      right: 0;
      top: 0;
    }

    &__details {
    }

    &__divider {
      > span {
        border-radius: 50%;
        border: 1px solid $color-white;
        display: block;
        height: 1.5rem;
        width: 1.5rem;
      }

      &::before,
      &::after {
        background-color: $color-white;
        content: "";
        display: block;
        position: absolute;
        top: 50%;
      }

      &::before {
        height: 1px;
        left: 1.5rem;
        width: calc(100% - 1.5rem);
      }

      &::after {
        height: 100vh;
        right: 0;
        width: 1px;
      }
    }
  }
}
</style>
